import initialState from '../initial-state';
import * as types from '../actions/action-types';

export function labelsReducer(state = initialState.labels, action) {
	switch (action.type) {
		case types.GET_LABELS:
			return action.labels;
		default:
			return state;
	}
}
